import { useEffect } from 'react';

const EfetivacaoEvaluator = ({
  contraSenha,
  resultadoContraSenha,
  codigoUsuarioAutorizacao,
  senha,
  credenciaisValidas,
  onUpdate,
  autorizando,
  travarVenda,
}) => {
  useEffect(() => {
    let podeEfetivar = false;
    const autorizaComLogin = (codigoUsuarioAutorizacao && senha && credenciaisValidas);
    if (contraSenha && contraSenha === resultadoContraSenha.toString())
      podeEfetivar = true;
    if (autorizaComLogin)
      podeEfetivar = true;
    if((travarVenda.travarCorretor || travarVenda.travarGerente) && !autorizaComLogin){
      podeEfetivar = false;
    }
    onUpdate(podeEfetivar || autorizando);
  }, [contraSenha, codigoUsuarioAutorizacao, senha, credenciaisValidas]);
  return null;
};

export default EfetivacaoEvaluator;
